export enum ExtraPaymentFaultValue {
  BUDSIES = "bf55e6e6-787a-4ad9-90a2-61efb455836f",
  CUSTOMER = "9f410c44-b826-45b5-aefc-c16674c74151",
}
